import { render, staticRenderFns } from "./ModalPresentation.vue?vue&type=template&id=1cf77f59&scoped=true&"
import script from "./ModalPresentation.vue?vue&type=script&lang=js&"
export * from "./ModalPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf77f59",
  null
  
)

export default component.exports